import styles from './browse-filter-bar.module.css'

import React, { useCallback } from 'react'

import {
  applyBrowseFilters,
  clearBrowseSearchTerm,
} from '@disco/state-management/actions/SearchActions'
import { selectSearchPage } from '@disco/state-management/reducers/search-page'
import { getSearch } from '@disco/state-management/selectors/search'

import type { FilterState } from 'types/filter-page'

import { Flex } from 'components/ds'

import { useDispatch, useSelector } from 'hooks/use-redux'

import FilterBar from './filter-bar'

// STL-1250: connects the shared filter bar to Browse, whose search box still uses the old state
const BrowseFilterBar = (): React.ReactNode => {
  const dispatch = useDispatch()
  const { filters } = useSelector(selectSearchPage)
  const search = useSelector(getSearch)

  const applyFilters = useCallback(
    (value: FilterState[]) => {
      dispatch(applyBrowseFilters(value))
    },
    [dispatch],
  )

  const clearAll = useCallback(
    (value: FilterState[]) => {
      dispatch(clearBrowseSearchTerm())
      dispatch(applyBrowseFilters(value))
    },
    [dispatch],
  )

  return (
    // Stays on one line so overflow badges collapse into "+N more" instead of wrapping
    <Flex
      className={styles.browseFilterBar}
      wrap="nowrap"
      gap={{ initial: '1', sm: '2' }}
      align="center"
      minWidth="0"
    >
      <FilterBar
        filters={filters}
        hasQuery={Boolean(search.searchTerm)}
        seedFixedFilters={false}
        collapseOverflow
        onChange={applyFilters}
        onClearAll={clearAll}
      />
    </Flex>
  )
}

export default BrowseFilterBar
